module.exports = __webpack_public_path__ + "img/fastvaluedeal-countdown.6c3057a8.png";